import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Dropdown from '@comp/Dropdown/Dropdown';
import { Spacings, Fonts } from '@styles/index';
import LanguageAlphabet from '@icon/LanguageAlphabet';

const StyledDropdown = styled(Dropdown)`
  padding: 0px;
  border: none;
  background: transparent;
  box-shadow: none;
  width: fit-content;
  font-weight: normal;
  height: 18px;
  font-size: ${Fonts.ULTRA_SMALL};
  svg {
    margin-left: ${Spacings.SPACING_6};
  }
  :hover {
    box-shadow: none;
  }
  & > .iconWrapper {
    margin-right: ${Spacings.SPACING_2};
  }
`;

const LanguageDropdown = ({ options, selectedOption, onLanguageChange }) => (
  <StyledDropdown
    options={options}
    selectedOption={selectedOption}
    menuWidth="150px"
    displayIcon={<LanguageAlphabet size="16px" />}
    onOptionClick={onLanguageChange}
  />
);

export default LanguageDropdown;

LanguageDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedOption: PropTypes.objectOf(PropTypes.any).isRequired,
  onLanguageChange: PropTypes.func.isRequired
};
